import { get } from 'services/api';
import { API_V4_BASE_URL } from 'settings';

const receiveRedirect = (url: string) => ({
  type: 'RECEIVE_REDIRECT',
  url,
});

const receiveRedirectError = (hasError: boolean) => ({
  type: 'RECEIVE_REDIRECT_ERROR',
  hasError,
});

export const getProducerUrl = (courseHash: string) => (dispatch: Function) => {
  return get({
    baseURL: API_V4_BASE_URL,
    url: `/learner/redirect/${courseHash}`,
  })
    .then((response) => {
      dispatch(receiveRedirect(response.data));
    })
    .catch(() => {
      dispatch(receiveRedirectError(true));
    });
};
